import { render, staticRenderFns } from "./ClinicalProfile.vue?vue&type=template&id=57b28616&"
import script from "./ClinicalProfile.vue?vue&type=script&lang=js&"
export * from "./ClinicalProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports